import withStyles from '@material-ui/core/styles/withStyles';
import FlightIcon from '@serko/zui-icons/es/FlightIcon';
import React, { PureComponent } from 'react';
import { compose } from 'recompose';
import { AirLeg } from '../../../../../../../../models/itinerary';
import { Logo } from './Logo';

interface OwnProps {
  /**
   * Airline provider code
   *
   * @example
   * "VA" // Virgin Airways
   */
  code: AirLeg['airlineCode'];

  /**
   * Airline name
   *
   * @example
   * "Virgin Airways"
   */
  name: AirLeg['airlineName'];
}

interface AirLogoProps extends OwnProps {}

class AirLogoBase extends PureComponent<AirLogoProps> {
  private get src() {
    return `./airline-logos/${this.props.code}_1x.png`;
  }

  public render() {
    const { name, code, ...props } = this.props;
    return (
      <Logo src={this.src} alt={name} fallbackIcon={FlightIcon} {...props} />
    );
  }
}

const enhance = compose<AirLogoProps, OwnProps>(
  withStyles({}, { name: 'ZuiImage' }), // Logos component is expecting the element.type.options.name to be 'ZuiImage'
);

export const AirLogo = enhance(AirLogoBase);

AirLogo.displayName = 'AirLogo';
